/*
 * GENERATED FROM tokens.json BY scripts/build-tokens.mjs — DO NOT EDIT.
 * Change the value in tokens.json and run `pnpm --filter @homecare/ui tokens:build`.
 * `pnpm verify:tokens` fails the build if this file has drifted from its source.
 */
export const STATUS_GLYPH = {
    verified: 'check',
    scheduled: 'clock',
    progress: 'pulse',
    warning: 'triangle',
    critical: 'octagon',
    inactive: 'minus',
};
export const STATUS_TONES = Object.keys(STATUS_GLYPH);
//# sourceMappingURL=status.js.map